
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(
        @Inject(DOCUMENT) private dom: Document,
        private titleSvc: Title,
        private meta: Meta
    ) { }

    updateTitle(title: string) {
        // facebook openGraph
        this.meta.updateTag({ name: 'og:title', title })
        // Google
        return this.titleSvc.setTitle(title)
    }

    updateDesc(content: string) {
        // facebook openGraph
        this.meta.updateTag({ name: 'og:description', content })
        // Google
        return this.meta.updateTag({ name: 'description', content })
    }

    createCanonicalLink(url?: string) {
        const canURL = url == undefined ? this.dom.URL : url;
        const link: HTMLLinkElement = this.dom.createElement('link')

        link.setAttribute('rel', 'canonical')
        link.setAttribute('href', canURL)

        this.dom.head.appendChild(link)
    }

    setMetaTags(title: string, description: string, route: string) {
        this.meta.updateTag({ name: 'title', title })
        this.meta.updateTag({ name: 'description', description })

        this.meta.updateTag({ property: 'og:title', content: title })
        this.meta.updateTag({ property: 'og:description', content: description })
        this.meta.updateTag({ property: 'og:type', content: 'website' })
        this.meta.updateTag({ property: 'og:url', content: `https://golfoneapp.one/${route}` })
        this.meta.updateTag({ property: 'og:image:alt', content: 'GolfONE Branded Logo' })
    }
}
